import * as Sentry from '@sentry/vue'

/**
 * 缓存工具类
 */
export class CacheUtils {
  /**
   * 安全地清除localStorage中的指定key
   * @param {string} key - 要清除的localStorage key
   */
  static clearLocalStorage(key) {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  /**
   * 安全地设置localStorage
   * @param {string} key - localStorage key
   * @param {any} value - 要存储的值
   */
  static setLocalStorage(key, value) {
    try {
      localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value))
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  /**
   * 安全地获取localStorage
   * @param {string} key - localStorage key
   * @param {any} defaultValue - 默认值
   */
  static getLocalStorage(key, defaultValue = null) {
    try {
      const value = localStorage.getItem(key)
      if (!value) return defaultValue

      try {
        return JSON.parse(value)
      } catch (parseError) {
        return value
      }
    } catch (error) {
      Sentry.captureException(error)
      return defaultValue
    }
  }
}

// 导出便捷方法
export const { clearLocalStorage } = CacheUtils
export const { setLocalStorage } = CacheUtils
export const { getLocalStorage } = CacheUtils
